import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaLinkedinIn, FaGithub, FaWhatsapp, FaEnvelope,
  FaFolderOpen, FaDownload, FaChevronDown, FaChartLine,
} from 'react-icons/fa';
import '../styles/home.css';

function Home() {
  return (
    <section className="hero" style={{ position: 'relative' }}>
      <div className="hero__inner">

        <div className="hero__content">
          <div className="hero__badge">
            <FaChartLine className="hero__badge-icon" />
            Data Analyst Portfolio
          </div>
          <h1 className="hero__name">Haadi<br /><span>Yakubu.</span></h1>
          <p className="hero__tagline">I turn raw data into real decisions.</p>
          <p className="hero__description">
            Detail-oriented data analyst based in <strong>Wa, Ghana</strong>, proficient in{' '}
            <strong>Excel, Power BI, SQL &amp; Python</strong>. I design intuitive dashboards,
            streamline logistics data, and deliver insights that drive strategic decisions.
          </p>

          <div className="hero__stats">
            <div>
              <div className="hero__stat-value">3+</div>
              <div className="hero__stat-label">Years Experience</div>
            </div>
            <div>
              <div className="hero__stat-value">60%</div>
              <div className="hero__stat-label">Reading Engagement ↑</div>
            </div>
            <div>
              <div className="hero__stat-value">30+</div>
              <div className="hero__stat-label">Libraries Supported</div>
            </div>
          </div>

          <div className="hero__cta">
            <Link to="/projects" className="btn-primary">
              <FaFolderOpen /> View Projects
            </Link>
            <a href="/HaadiYakubu_DataAnalyst_Resume.pdf" target="_blank" rel="noopener noreferrer" className="btn-outline">
              <FaDownload /> Download CV
            </a>
          </div>

          <div className="hero__social-strip">
            <a href="https://www.linkedin.com/in/haadi-yakubu" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="https://github.com/Hardy999" target="_blank" rel="noopener noreferrer" aria-label="GitHub"><FaGithub /></a>
            <a href="mailto:hardyyaqub@gmail.com" aria-label="Email"><FaEnvelope /></a>
            <a href="https://wa.me/233556387424" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"><FaWhatsapp /></a>
          </div>
        </div>

        <div className="hero__photo-wrap">
          <img
            className="hero__photo"
            src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80&fit=crop"
            alt="Haadi Yakubu"
          />
          <div className="hero__photo-border"></div>
        </div>
      </div>

      <div className="hero__scroll">
        <span>scroll</span>
        <FaChevronDown className="hero__scroll-icon" />
      </div>
    </section>
  );
}

export default Home;